import React from 'react';

import './styles.css';
import Score from '../Score';

type Props = {
  totalScore: number;
  setTotalScore: any;
};

const ScoreBoard = ({
  totalScore,
  setTotalScore,
}: Props) => {
  const board = [
    {
      value: 2,
      score: 100,
    },
    {
      value: 3,
      score: 70,
    },
    {
      value: 4,
      score: 60,
    },
    {
      value: 5,
      score: 50,
    },
    {
      value: 6,
      score: 40,
    },
    {
      value: 7,
      score: 30,
    },
    {
      value: 8,
      score: 40,
    },
    {
      value: 9,
      score: 50,
    },
    {
      value: 10,
      score: 60,
    },
    {
      value: 11,
      score: 70,
    },
    {
      value: 12,
      score: 100,
    }
  ];

  function changeValue(amount: number) {
    setTotalScore(totalScore + amount);
  }

  return (
    <div className={'score-board'}>
      {board.map(item => (<div key={`value-${item.value}`}><Score value={item.value} score={item.score} callback={changeValue} /></div>))}
    </div>
  );
};

export default ScoreBoard;